import * as React from 'react';
import DataTable from "src/Components/DataTable";
import { IDispatchTruck } from "src/Interfaces/DispatchInterface";


interface IReceiveDispatchProps {
    dispatchTruck: IDispatchTruck | undefined;
}

export class ReceiveDispatchTable extends React.Component {
    public props: IReceiveDispatchProps;

    constructor(props: any) {
        super(props);
    }

    private formatDataTableProduct = () => {
        const headers = [
            'Item',
            'Category',
            'Unit',
            'Size',
            'Quantity',
        ];

        if (!this.props.dispatchTruck)
        {
            return {
                headers,
                rows: []
            };
        }

        const list = this.props.dispatchTruck.items;

        const rows: any = [];

        list.forEach((row, index) => {
            if (row.product) {
                const tempRow = [
                    {
                        content: row.product.name
                    },
                    {
                        content: row.product.categorys.length > 0 ? row.product.categorys[0].name : ''
                    },
                    {
                        content: row.product.unit
                    },
                    {
                        content: row.product.size
                    },
                    {
                        content: row.quantity,
                    }
                ];
                rows.push(tempRow);
            }

            if (row.expense) {
                const tempRow = [
                    {
                        content: row.expense.name
                    },
                    {
                        content: row.expense.isRental ? 'Rental' : 'Service'
                    },
                    {
                        content: ''
                    },
                    {
                        content: ''
                    },
                    {
                        content: row.quantity,
                    }
                ];
                rows.push(tempRow);
            }
        });

        const retList = {
            headers,
            rows,
        };
        
        return retList;
    }

    public render() {
        return (
            <DataTable
                list={this.formatDataTableProduct()}
            />
        );
    }

}


// WEBPACK FOOTER //
// ./src/Components/Main/Dispatch/ReceiveDispatch/ReceiveDispatchTable.tsx